import * as Actions from 'reducks/storeDeliverySetting/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const StoreDeliverySettingReducer = (state = initialState.storeDeliverySetting, action: any) => {
  switch (action.type) {
    case Actions.FETCH_STORE_DELIVERY_SETTINGS:
      return {
        storeDeliverySettings: [...action.payload],
      }
    case Actions.INIT_STORE_DELIVERY_SETTINGS:
      return {
        storeDeliverySettings: [],
      }
    default:
      return state
  }
}
